import get from 'lodash/get';
import 'rxjs/add/operator/combineLatest';
import {buildPropsByCollection} from '../../redux/utils';
import {buildGoBack} from '../../utils';


export const RequirementViewActivityContainer = (config) => (state$, dispatch) => (props$) => {
  const {
    collection,
    taskListState,
    taskDetailsState,
  } = config;

  const {
    stateParams$,
    requirement$,
    breadcrumbPath$,
  } = buildPropsByCollection(collection, state$, props$);

  const onGoBack = buildGoBack({
    props$,
    requirement$,
    taskListState,
    taskDetailsState,
    dispatch,
  });

  return props$
    .combineLatest(
      stateParams$,
      requirement$,
      breadcrumbPath$,
      (props, stateParams, requirement, breadcrumbPath) => ({
        ...props,
        feedId: get(stateParams, 'requirementId'),
        collection,
        // init: !!requirement,
        requirement,
        breadcrumbPath,
        onGoBack,
      }));
};



// WEBPACK FOOTER //
// ./src/js/requirements/components/RequirementViewActivity/RequirementViewActivityContainer.js